import styles from './title.module.css'
import logo from '../../assets/gfx/logo.webp'

function TitleSlide({menuOpen, setMenuOpen, lang, setLang}) {
    return (
        <div className={`${styles.background} ${styles.container}`}>
            <div className={styles.navigation}>
                <a className={styles['navigation-link']} href="#concept">concept</a>
                <a className={styles['navigation-link']} href="#teams">teams</a>
                <a className={styles['navigation-link']} href="#join">join</a>
                <a className={styles['navigation-link']} href="#sponsor">sponsor</a>
                <div className={styles['navigation-divider']}>|</div>
                <span className={styles['navigation-burger']} onClick={() => setMenuOpen(!menuOpen)}></span>
                <span className={`${styles['navigation-link']} ${styles['always']}`} href="#" onClick={() => setLang(lang === 'JA' ? 'EN' : 'JA')}>{lang === 'JA' ? 'EN' : 'JA'}</span>
                {/* --- */}
            </div>
            <div className={styles.content}>
                <img width="75%" src={logo} alt="logo"/>
            </div>
        </div>
    )
}

export default TitleSlide